<template>
  <pt-promotion-form ref="form" class="pt-promotion-form__withData" :form="promotionDetail" :groupList="groupList" :isEdit="isEdit" :loading="loading"
                     :isActive="isActive" :businessDepartments="businessDepartments"></pt-promotion-form>
</template>

<script>
import PtPromotionForm from './form'
import { isEmptyObject } from '@/utils/formUtils'
export default {
  name: 'pt-promotion-form__withData',
  components: {
    'pt-promotion-form': PtPromotionForm
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  data () {
    return {
      promotionDetail: {
        promotionData: {},
        fullReductionDiscount: {
          fullReductions: [
            {}
          ],
          openFullReduction: false
        }
      },
      promotion_detail_res: {},
      groupList: [],
      loading: false,
      mallUserQuery: [],
      businessDepartments: []
    }
  },
  methods: {
    getBusinessDepartment () {
      this.$store.dispatch('getBusinessDepartment').then(res => {
        this.businessDepartments = res
      }).catch(err => {
        this.$message.error(err || '获取业务部列表失败')
      })
    },
    // 判断是否已选择用户
    isSelectedUser () {
      let importCustomer = false
      let formValue = this.form.formValue || {}
      if (formValue.mallUserCriteria && formValue.mallUserCriteria.whiteList &&
      formValue.mallUserCriteria.whiteList.length) {
        formValue.mallUserCriteria.whiteList.forEach(item => {
          for (let key in item) {
            if (item[key] || item.bindCps === false) {
              importCustomer = true
            }
          }
          // if (item.userListId) {
          //   importCustomer = true
          // } else if (item.ids) {
          //   importCustomer = true
          // }
        })
      }
      return importCustomer
    },
    // 编辑的时候，新选择用户，如果有导入的数据，删除上次导入数据
    editHasImportData () {
      let obj = {
        importCustomerDetail: false
      }
      if (this.promotion_detail_res.mallUserCriteria && this.promotion_detail_res.mallUserCriteria && this.promotion_detail_res.mallUserCriteria.whiteList &&
      this.promotion_detail_res.mallUserCriteria.whiteList.length) {
        this.promotion_detail_res.mallUserCriteria.whiteList.forEach(item => {
          if (item.userListId) {
            obj.importCustomerDetail = true
            obj.userListId = item.userListId
          }
        })
      }
      return obj
    },
    submit () {
      this.form.validate().then(formValue => {
        if (formValue.type === 'CPS_BIND') {
          if (formValue.reword_money_show) {
            this.$delete(formValue, 'reword_money_show')
          }
        }
        if (formValue.fullReductionDiscount.openFullReduction) {
          if (!formValue.fullReductionDiscount.fullReductionType) {
            this.$message.error('请选择满减形式')
            return
          }
          formValue.fullReductionDiscount.fullReductions.forEach((item, index) => {
            if (isEmptyObject(item)) {
              formValue.fullReductionDiscount.fullReductions.splice(index, 1)
            }
            item.discount = item.discount_show && item.discount_show * 100
            item.discountCondition = formValue.fullReductionDiscount.fullReductionType === 'MONEY' ? (item.discountCondition_show && item.discountCondition_show * 100) : item.discountCondition_show
          })
          if (!formValue.fullReductionDiscount.fullReductions.length) {
            this.$message.error('请填写满减内容')
            return
          }
        }
        if (formValue.promotionData && formValue.promotionData.promotionType === 'CASH_BACK' && !this.isSelectedUser()) {
          this.$message.error('请至少选择一个分享者或导入分享者')
        } else {
          this.businessDepartments.forEach(item => {
            if (item.id === formValue.businessDepartmentId) {
              formValue.businessDepartmentName = item.name
            }
          })
          this.$emit('submitLoad')
          formValue.type = formValue.promotionData.promotionType
          formValue.status = this.isEdit ? 'WAITING_AUDIT' : null
          formValue.mallUserQueryData = null
          if (formValue.userInfo) {
            this.$delete(formValue, 'userInfo')
          }
          this.$nextTick(_ => {
            let apiUrl = this.isEdit ? 'promotionEdit' : 'createPromotion'
            this.$store.dispatch(apiUrl, formValue).then(data => {
              // doing something ...
              this.$message.success(this.isEdit ? '编辑促销活动成功' : '新建促销活动成功')
              history.go(-1)
              // this.$router.push('/promotion-coupon?type=promotion')
              this.$emit('submitOver')
            }).catch(errorMessage => {
              this.$emit('submitOver')
              this.$message.error(errorMessage)
            })
          })
        }
      })
    },
    getPromotionDetail () {
      this.loading = true
      this.$store.dispatch('promotionDetail', this.id).then(res => {
        this.promotionDetail = res
        this.promotion_detail_res = JSON.parse(JSON.stringify(res))
        this.loading = false
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取促销活动详情失败')
      })
    },
    getGroupList () {
      let data = {
        example: {},
        pageable: {
          page: 0,
          size: 99999
        }
      }
      this.$store.dispatch('getGoodsGroup', data).then(res => {
        this.groupList = res.data
        res.data.forEach((item, index) => {
          if (item.id === 'gene-unlock') {
            res.data.splice(index, 1)
          }
        })
        this.groupTabs = res.data
        this.selectTab = res.data && res.data[0] && res.data[0].id
      }).catch(err => {
        this.$message(err || '获取商品分组列表失败')
      })
    }
  },
  created () {
    this.getBusinessDepartment()
    this.getGroupList()
    if (this.isEdit) {
      this.getPromotionDetail()
    }
  }
}
</script>
